import {
  MelcoModelsUserMachineLicenseListItem,
  useAPIQuery,
  UserAccountApi,
  useTable,
} from "melco-shared-logic";
import { useTableErrorComponent } from "../../table/useTableErrorComponent";

export const useMachineLicenses = (
) => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<MelcoModelsUserMachineLicenseListItem>();

  const query = useAPIQuery(
    UserAccountApi,
    ["machineLicenses", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api) => {
      const response = await api.accountGetLicenses({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
      });

      setTotal(response.total);

      return response.list;
    },
    
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
